import React, { useContext } from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Tooltip,
  IconButton,
  Box
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { MenuBook } from '@mui/icons-material';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import FolderIcon from '@mui/icons-material/Folder';
import SupportAgent from '@mui/icons-material/SupportAgent';
import DescriptionIcon from '@mui/icons-material/Description';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import ChatIcon from '@mui/icons-material/Chat';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import logoImg from '../assets/logo.png'; // percorso del logo
import googleCalendarApi from '../api/googleCalendarApi';

const drawerWidth = 240;

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  if(!user) return <div> Loading ...</div>
  console.log("user",user);
    const handleEnableCalendar = async () => {
      try {
        const url = await googleCalendarApi.getAuthorizationUrl(user.id);
        window.location.href = url; // reindirizza a OAuth
      } catch (err) {
        console.error('Errore abilitazione Google Calendar', err);
      }
    };

    const handleDisableCalendar = async () => {
      try {
        await googleCalendarApi.disableCalendar(user.id);
        refreshUser(); // aggiorna contesto per nascondere bottoni
      } catch (err) {
        console.error('Errore disabilitazione Google Calendar', err);
      }
    };
  const items = [
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Dashboard', to: '/dashboard', icon: <DashboardIcon /> }]
      : []),
    ...(user?.role === 'STUDIO' && user?.studioId
      ? [{ label: 'Dashboard', to: `/dashboard/studio/${user.studioId}`, icon: <DashboardIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE'
      ? [{ label: 'Dashboard', to: `/dashboard/contribuente/${user.contribuenteId}`, icon: <DashboardIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Utenti', to: '/users', icon: <PeopleIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Studi', to: '/studi', icon: <BusinessIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Audit', to: '/audit', icon: <PeopleIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Contribuenti', to: '/contribuenti', icon: <FolderIcon /> }]
      : []),
    ...(user?.role === 'STUDIO'
      ? [{ label: 'Contribuenti', to: `/contribuenti/bystudio/${user.studioId}`, icon: <FolderIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE'
      ? [{ label: 'Documenti e Scadenze', to: `/documenti/bycontribuente/${user.contribuenteId}`, icon: <DescriptionIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE'
        ? [{ label: 'Calendario Scadenze', to: '/scadenze/calendar', icon: <CalendarMonth /> }]
        : []),
    ...(user?.role === 'STUDIO'
        ? [{ label: 'Calendario Scadenze', to: '/scadenze/calendar', icon: <CalendarMonth /> }]
        : []),
    ...(user?.role === 'CONTRIBUENTE'
      ? [{ label: 'Genera report', to: `/contribuenti/report/${user.contribuenteId}`, icon: <DescriptionIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE' || user?.role === 'STUDIO'
      ? [{ label: 'Visualizza contratto', to: `/contratti/${user.contrattoId}`, icon: <BusinessIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Richieste Demo', to: '/richiestedemo', icon: <PeopleIcon /> }]
      : []),
      ...(user?.role === 'ADMIN' || user?.role === 'STUDIO' || user?.role === 'CONTRIBUENTE'
        ? [{ label: 'Notifiche', to: '/notifiche', icon: <PeopleIcon /> }]
        : []),
      ...(user?.role === 'CONTRIBUENTE'
        ? [{ label: 'Il mio Fascicolo', to: '/fascicolo/me', icon: <FolderIcon /> }]
        : []),
      ...[{ label: 'Tickets', to: '/tickets', icon: <SupportAgent /> }],
      ...(user?.chatisactive === true
       ? [{ label: 'Chat', to: '/chatrooms', icon: <ChatIcon /> }]
       : []),
   ...(user?.role === 'ADMIN'
     ? [{ label: 'Mailing list', to: '/precampagna', icon: <PeopleIcon /> }]
     : []),
    ...(user?.role === 'CONTRIBUENTE' && user?.calendarEnabled
      ? [
          !user.googleCalendarEnabled
            ? { label: 'Abilita notifiche Google Calendar', onClick: handleEnableCalendar, icon: <CalendarTodayIcon /> }
            : { label: 'Disabilita notifiche Google Calendar', onClick: handleDisableCalendar, icon: <CalendarTodayIcon /> }
        ]
      : [])
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
      }}
    >
      <Toolbar />
      {/* LOGO */}
      <Box sx={{ textAlign: 'center', my: 2 }}>
        <img src={logoImg} alt="TaxFlow" style={{ maxWidth: '120px' }} />
      </Box>
         <Box sx={{ textAlign: 'center', my: 2 }}>
             <Tooltip title="Manuale utente">
               <IconButton
                 variant="outlined" color="primary"
                 size="large"
                 onClick={() => window.open(`${process.env.PUBLIC_URL}/manualeUtente.pdf`, '_blank')}
               >
                 <MenuBook />
               </IconButton>
             </Tooltip>
         </Box>
      <List>
        {items.map((i) => {
          const selected = location.pathname.startsWith(i.to);
          return (
            <ListItemButton
              key={i.to}
              selected={selected}
              onClick={() => navigate(i.to)}
            >
              <ListItemIcon>{i.icon}</ListItemIcon>
              <ListItemText primary={i.label} />
            </ListItemButton>
          );
        })}
      </List>

    </Drawer>
  );
}
